import React, { useState } from "react";
import CustomPagination from "../../../components/CustomPagination";
import { formatDateTime, maxLengthText } from "../../../utils/format";
import { ThunkDispatch } from "@reduxjs/toolkit";
import { useSelector, useDispatch } from "react-redux";
import { 
    setCurrentPage,
    TableHeader,
    handleSortByHeader,
} from "../../../reducers/companyHistory";

const HistoryList = ({ historyList }: any) => {
    const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
    const {
        currentPage,
        countItems,
        pageSize,
        tableHeaders,
    } = useSelector((state: any) => state.companyHistory);
    
    const historyRecord = historyList.map((item: any) => ({
        dateTime: formatDateTime(item.created_at),
        fullname: item.staff.fullname,
        department: item.staff.department.name,
        post: item.staff.position.name,
        authority: item.staff.staff_type_display.name,
        type: item.type,
        screen: item.screen_name,
        detail: item.detail,
    }));

    const handleChangePage = (pageNumber: any) => {
        dispatch(setCurrentPage(pageNumber));
    };

    const handleSort = (sortHeader: TableHeader) => {
        dispatch(handleSortByHeader(sortHeader));
    };

    return (
        <>
        <div className="bg-white rounded-lg">
            <table className="table-auto w-full">
            <thead className="border-b alu-border px-4 py-2">
                <tr>
                {tableHeaders.map((header: TableHeader, index: number) => (
                    <th key={index} className={`px-4 py-2 text-left ${header.customStyle}`}>
                    <div
                        className="flex items-center"
                        onClick={() => header.isSort && handleSort(header)}
                    >
                        <p
                        className={`${
                            header.currentSortState !== 0
                            ? "font-bold underline underline-offset-4 alu-text-base-2"
                            : "font-normal alu-text-base-1"
                        } ${
                            header.isSort ? "hover:cursor-pointer" : ""
                        } text-sm leading-[1.3125]`}
                        >
                        {header.title}
                        </p>
                        {header.isSort && (
                        <button
                            className={`${
                            header.currentSortState === 2
                                ? "rotate-180"
                                : "rotate-0"
                            }`}
                        >
                            <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            >
                            <g clipPath="url(#clip0_8574_176)">
                                <path d="M7 10L12 15L17 10H7Z" fill="#808080" />
                            </g>
                            <defs>
                                <clipPath id="clip0_8574_176">
                                <rect width="24" height="24" fill="white" />
                                </clipPath>
                            </defs>
                            </svg>
                        </button>
                        )}
                    </div>
                    </th>
                ))}
                </tr>
            </thead>
            <tbody>
                {historyRecord.map((history: any, idx: number) => (
                <tr key={idx} className={`border-t border-t-[#E0E0E0] hover:bg-[#fff3e5] h-[2.3125rem]`}>
                    <td className="px-4 py-2 text-left font-normal text-sm leading-[1.3125] alu-text-base-2 break-all">
                    {history.dateTime}
                    </td>
                    <td className="px-4 py-2 text-left font-normal text-sm leading-[1.3125] alu-text-base-2 break-all">
                    {history.fullname}
                    </td>
                    <td className="px-4 py-2 text-left font-normal text-sm leading-[1.3125] alu-text-base-2 break-all">
                    {history.department}
                    </td>
                    <td className="px-4 py-2 text-left font-normal text-sm leading-[1.3125] alu-text-base-2 break-all">
                    {history.post}
                    </td>
                    <td className="px-4 py-2 text-left font-normal text-sm leading-[1.3125] alu-text-base-2 break-all">
                    {history.authority}
                    </td>
                    <td className="px-4 py-2 text-left font-normal text-sm leading-[1.3125] alu-text-base-2 break-all">
                    {history.type}
                    </td>
                    <td className="px-4 py-2 text-left font-normal text-sm leading-[1.3125] alu-text-base-2 break-all">
                    {history.screen}
                    </td>
                    <td className="px-4 py-2 text-left font-normal text-sm leading-[1.3125] alu-text-base-2 break-all">
                    {maxLengthText(history.detail, 100)}
                    </td>
                </tr>
                ))}
            </tbody>
            </table>
        </div>
        {countItems > pageSize && (
        <div className="flex items-center justify-center mt-6">
            <CustomPagination 
                total={countItems} 
                currentPage={currentPage}
                pageSize={pageSize} 
                onPageChange={handleChangePage} 
                shape="circle"
            />
        </div>
        )}
        </>
    );
};

export default HistoryList;